// RU-STRATLINK SL-12: `ref <first 8 chars of the id>` with a copy button for the full id. Display only.
// RU-REFVIS: legible in both themes: value in the primary colour at 11px, label secondary, strong border + surface-2.
import { Copy } from "lucide-react";
import { copyStrategyId, strategyRef } from "@/lib/strategyRef";
import { openStrategyDrawer } from "@/lib/strategyDrawer";

// RU-STRATDRILL SD-1: a click on the chip (not its copy button) opens the shared strategy drawer; `openable={false}`
// inside the drawer itself.
export default function StrategyRefChip({ id, name, testid, className = "", openable = true }) {
  if (!id) return null;
  const stop = (e) => {                          // never the row / card underneath
    e.stopPropagation();
    if (openable) openStrategyDrawer({ id: String(id), name });
  };
  // SD-17: Enter / Space on the chip itself opens; on its copy button they only copy (the button's own click)
  const onKey = (e) => {
    if (!openable || e.target !== e.currentTarget || (e.key !== "Enter" && e.key !== " ")) return;
    e.preventDefault();
    e.stopPropagation();
    openStrategyDrawer({ id: String(id), name });
  };
  const a11y = openable ? { role: "button", tabIndex: 0, onKeyDown: onKey, "aria-label": `Open strategy ${strategyRef(id)}` } : {};
  return (
    <span className={`inline-flex items-center gap-1 font-mono-data text-[11px] leading-none px-1.5 py-0.5 rounded-sm border border-[var(--border-strong)] bg-[var(--bg-surface-2)] whitespace-nowrap align-middle ${openable ? "cursor-pointer" : ""} ${className}`}
          title={String(id)} onClick={stop} {...a11y} data-testid={testid ? `${testid}-chip` : undefined}>
      <span className="txt-secondary" data-testid={testid ? `${testid}-label` : undefined}>ref</span>
      <span title={String(id)} className="text-[var(--text-primary)] font-medium" data-testid={testid}>{strategyRef(id)}</span>
      <button type="button" aria-label="Copy strategy id" title={`Copy full id ${id}`}
              onClick={(e) => { e.stopPropagation(); copyStrategyId(id); }}
              className="txt-secondary hover:text-[var(--text-primary)]" data-testid={testid ? `${testid}-copy` : undefined}>
        <Copy className="w-3 h-3" />
      </button>
    </span>
  );
}
